import { doc, DocumentReference } from 'firebase/firestore';
import { docData } from 'rxfire/firestore';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { getPredefinedDateRange } from '../../../../utils/date';
import { IRange, ISelectableTag, IUser } from '../../../types';
import { authenticatedUserProvider } from '../../userProvider';

export interface IEurReportSettings {
  cmjTags: ISelectableTag[];
  squatTags: ISelectableTag[];
  timeframe: IRange;
}

const defaultSettings: IEurReportSettings = {
  cmjTags: [],
  squatTags: [],
  timeframe: getPredefinedDateRange('month'),
};

/**
 * @description observes dashboard settings
 */
export const eurReportSettingsProvider = (): Observable<IEurReportSettings> => {
  return authenticatedUserProvider().pipe(
    switchMap((user: IUser): Observable<IEurReportSettings> => {
      return docData(
        doc(
          user.services.firestore,
          `userProfiles/${user.id}/settings/eurReport`
        ) as DocumentReference<IEurReportSettings>
      ).pipe(
        map((settings: IEurReportSettings): IEurReportSettings => {
          return { ...defaultSettings, ...settings };
        })
      );
    })
  );
};
